import React, { Component, Fragment } from 'react';

import { Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import InfiniteSccroll from 'react-infinite-scroller';
import { AxiosError } from 'axios';

import * as Service from '../services/ActivitiesService';
import * as PartiesService from '../services/PartiesService';
import '../styles/containers/Activities.css';
import Spinner from '../components/utils/Spinner';
import {
  setFilterData,
  setTag,
  setFilterFlag,
} from '../actions/activitiesActions';
import ActivitiesList from '../components/activities/ActivitiesList/ActivitiesList';
import ActivityFilterForm, {
  FilteredData,
} from '../components/forms/ActivityFilterForm';
import TopPanel from '../components/utils/TopPanel';
import {
  generateKeyStr,
  isMobileResolution,
  openLink,
  replaceSpaces,
} from '../infrastructure/utils/common';
import TableSortingElem from '../infrastructure/TableSorting';
import MobileTopPanelActions from '../components/utils/MobileTopPanelActions';
import MobileListSorter from '../components/utils/MobileListSorter';
import ActivityCreateModal from '../components/activities/ActivityModals/ActivityCreateModal/ActivityCreateModal';
import ActivitiesBulkUploadPreview from '../components/activities/ActivityModals/ActivitiesBulkUploadPreview/ActivitiesBulkUploadPreview';
import CSVImportService from '../services/CSVImportService';
import {
  concatBulkOptionsWithBulkActivity,
  mapFromActivityToActivityCSV,
  mapFromBookingOptionsToBookingOptionsCSV,
  parseActivitiesBulkUploadErrors,
} from '../infrastructure/utils/activities';
import { getConfig } from '../config';

const initialState = {
  activitiesLoaded: false,
  allActivities: false,
  isDeactive: false,
  filterData: null,
  tag: '',
  cities: [],
  creating: false,
  cityManagement: false,
  noData: false,
  key: generateKeyStr(),
  activeSort: null,
  avaliableSort: [],
  activities: null,
  isError: false,
  token: null,
  openModal: false,
  firstLoad: true,
  isMobileFilterSelected: false,
  isMobileSortSelected: false,
  isCreateModalOpen: false,
  isBulkUploadModalOpen: false,
  sendingStatus: false,
  csvActivities: [],
  csvBookingOptions: [],
  partyTypes: [],
};

interface ActivitiesProps {
  filterData: FilteredData;
  activeFilter: boolean;
  activateFilter: (flag: boolean) => void;
  clearTag: () => void;
  tag: string;
  history: any;
  setFilter: (data: FilteredData) => void;
}

class Activities extends Component<ActivitiesProps> {
  constructor(props) {
    super(props);
    this.state = initialState;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.term = '';
  }

  async componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
    const {
      filterData,
      activeFilter,
      activateFilter,
      clearTag,
      tag,
    } = this.props;
    const tags = await Service.getAllTags();
    const cities = await Service.getCities();
    const partyTypes = await PartiesService.listActivePartyTypes();
    this.setState({
      cities,
      tags: tags.map(t => t.name),
      partyTypes,
      hiddenTags: tags
        .filter(ftag => ftag.type === 'hidden')
        .map(htag => htag.name),
    });
    if (tag) {
      const filterDataWithTag = new FilteredData();
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterDataWithTag.tags.push(tag);
      clearTag();
      activateFilter(false);
      this.loadFirstActivities(filterDataWithTag);
      return;
    }
    if (activeFilter) {
      this.loadFirstActivities(filterData);
      activateFilter(false);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.loadFirstActivities();
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  loadFirstActivities = async filterData => {
    this.loadActivities({
      token: 0,
      firstLoad: true,
      order: new TableSortingElem({ name: 'title', isString: true }),
      filterData,
    });
  };

  handleActivityClick = (event, url) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filterData } = this.state;
    const { history, setFilter, activateFilter } = this.props;
    setFilter(filterData);
    activateFilter(true);
    openLink(event, url, history, !isMobileResolution());
  };

  loadCSVActivities = async () =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject) => {
      try {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const { activeSort, filterData } = this.state;
        const data = await Service.getAllActivities(
          activeSort,
          filterData,
          0,
          true
        );
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const csvActivities = data.map(mapFromActivityToActivityCSV);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const csvBookingOptionsArrays = data.map(
          mapFromBookingOptionsToBookingOptionsCSV
        );
        const csvBookingOptions = csvBookingOptionsArrays.reduce(
          (acm, current) => [...acm, ...current],
          []
        );
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        this.setState({ csvActivities, csvBookingOptions }, () => resolve());
      } catch (e) {
        const error = e as AxiosError;
        alert(
          `Error code: ${error?.response?.status} '\nError message: ${error?.response?.data}`
        );
        console.log(e);
        reject();
      }
    });

  loadMoreActivities = async () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { token, activeSort, filterData } = this.state;
    this.loadActivities({
      token,
      firstLoad: false,
      order: activeSort,
      filterData,
    });
  };

  getFilteredActivity = async filterData => {
    this.setState({ filterData });
    this.loadFirstActivities(filterData);
  };

  searchActivityByName = async val => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.term = val;
    if (val === '') {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.loadFirstActivities();
      return;
    }
    const data = await Service.searchByName(val);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (this.term === val) {
      this.setState({
        activities: data,
        key: generateKeyStr(),
        allActivities: true,
      });
    }
    const res = data.map(activity => ({
      label: activity.title,
      value: activity.id,
    }));
    // eslint-disable-next-line consistent-return
    return res.slice(0, 10);
  };

  onActivitySearched = id => {
    const config = getConfig();
    window.open(`${config.batchAdminURL}/experiences/${id}`, '_self');
  };

  handleOnTagClick = async (city, tag) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const data = await Service.getByTag(city, tag);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { deactive } = this.state;
    if (!deactive) {
      this.setState({
        token: null,
        activeSort: new TableSortingElem({ name: 'title', isString: true }),
        allActivities: true,
        activities: data,
        activitiesLoaded: true,
      });
    }
  };

  removeFilter = () => {
    this.setState({ filterData: undefined });
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadFirstActivities();
  };

  loadActivities = async ({ token, firstLoad, order, filterData }) => {
    const data = await Service.getAllActivities(order, filterData, token);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (data.length === 0) {
      if (firstLoad) {
        this.setState({ activities: [] });
      }
      this.setState({ allActivities: true });
      return;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { deactive } = this.state;
    if (!deactive) {
      if (firstLoad) {
        this.setState({
          activities: data,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          token: data.length,
          activeSort: order,
          key: generateKeyStr(),
          filterData,
          avaliableSort: [
            new TableSortingElem({ name: 'title', isString: true, up: true }),
            new TableSortingElem({ name: 'title', isString: true, up: false }),
            new TableSortingElem({ name: 'city', isString: true, up: true }),
            new TableSortingElem({ name: 'city', isString: true, up: false }),
            new TableSortingElem({
              name: 'bookable',
              up: true,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'bookable',
              up: false,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'bachified',
              up: true,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'bachified',
              up: false,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'featured',
              up: true,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'featured',
              up: false,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'popularity',
              up: true,
              isBoolean: true,
            }),
            new TableSortingElem({
              name: 'popularity',
              up: false,
              isBoolean: true,
            }),
          ],
          allActivities: false,
          activitiesLoaded: true,
        });
      } else {
        this.setState(state => ({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          activities: state.activities.concat(data),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          token: state.token + 25,
        }));
      }
    }
  };

  changeSort = name => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activeSort, avaliableSort, filterData } = this.state;
    let sort = null;
    if (activeSort.name === name) {
      sort = {
        ...activeSort,
        up: !activeSort.up,
      };
      this.setState({ activeSort: sort });
    } else {
      sort = avaliableSort.find(s => s.name === name);
      this.setState({ activeSort: sort });
    }
    this.loadActivities({
      token: 0,
      firstLoad: true,
      order: sort,
      filterData,
    });
  };

  changeSortBySelect = (name, up) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { avaliableSort, filterData } = this.state;
    const sort = avaliableSort.find(s => s.name === name);
    if (!sort) return;
    sort.up = up;
    this.setState({ activeSort: sort });
    this.loadActivities({
      token: 0,
      firstLoad: true,
      order: sort,
      filterData,
    });
  };

  closeBulkUploadPreview = () => {
    this.setState({ isBulkUploadModalOpen: false });
  };

  formAndDownloadBulkCSVErrors = (errorMessage, activities, bookingOptions) => {
    const {
      activitiesErrors,
      bookingOptionsErrors,
    } = parseActivitiesBulkUploadErrors(
      errorMessage,
      activities,
      bookingOptions
    );
    if (activitiesErrors.length > 0) {
      CSVImportService.exportAsCSVFile(activitiesErrors);
    }
    if (bookingOptionsErrors.length > 0) {
      CSVImportService.exportAsCSVFile(bookingOptionsErrors);
    }
  };

  onBulkUploadSend = async data => {
    const { activities, bookingOptions } = data;
    if (!activities || !activities.length) return;
    const activitiesWithBookingOptions = await Promise.all(
      activities.map(async activity =>
        concatBulkOptionsWithBulkActivity(activity, bookingOptions)
      )
    );
    try {
      this.setState({ sendingStatus: true });
      await Service.uploadBulkActivities(activitiesWithBookingOptions);
      this.loadMoreActivities();
    } catch (e) {
      /* eslint-disable prefer-destructuring */
      console.error(e);
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const status = e.response?.status;
      if (status === 400) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const errorMessage = e.response.data;
        this.formAndDownloadBulkCSVErrors(
          errorMessage,
          activities,
          bookingOptions
        );
        alert(errorMessage);
      }
    } finally {
      this.setState({ sendingStatus: false, isBulkUploadModalOpen: false });
    }
  };

  closeCreateModal = () => {
    this.setState({ isCreateModalOpen: false });
  };

  createPreSignedImgUrl = async (id, image) => {
    const result = await Service.createPreSignedImgUrl(
      id,
      replaceSpaces(image.name)
    );
    return result;
  };

  createActivity = async (activity, bookingOptions) => {
    try {
      this.setState({ sendingStatus: true });
      const copied = cloneDeep(activity);
      if (!bookingOptions.length) {
        copied.tags = copied.tags.filter(item => item !== 'bookable');
      }
      const created = await Service.createActivity(copied);
      if (bookingOptions.length > 0 && copied.tags.includes('bookable')) {
        await Promise.all(
          bookingOptions.map(option =>
            Service.createBookingOption(created.id, option)
          )
        );
      }

      const config = getConfig();

      window.location.assign(
        `${config.batchAdminURL}/experiences/${created.id}`
      );
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      this.setState({ sendingStatus: false });
      this.closeCreateModal();
    }
  };

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activitiesLoaded,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activities,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      key,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      tags,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      cities,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      allActivities,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileFilterSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileSortSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      avaliableSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isCreateModalOpen,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      sendingStatus,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isBulkUploadModalOpen,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      csvActivities,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      csvBookingOptions,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      partyTypes,
    } = this.state;
    if (!activitiesLoaded) {
      return <Spinner />;
    }
    return (
      <Fragment>
        {sendingStatus && (
          <div className='sending-status-loader'>
            <Spinner />
          </div>
        )}
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ActivityCreateModal
            isOpen={isCreateModalOpen}
            closeModal={this.closeCreateModal}
            allTags={tags}
            createActivity={this.createActivity}
            partyTypes={partyTypes}
          />
        }
        <ActivitiesBulkUploadPreview
          isOpen={isBulkUploadModalOpen}
          closeModal={this.closeBulkUploadPreview}
          onSend={data => this.onBulkUploadSend(data)}
        />
        <TopPanel>
          <h1
            className='col-md-6 col-sm-6 col-xs-6'
            style={{ marginTop: '0px' }}
          >
            <span className='fas fa-beer' /> Experiences
          </h1>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <MobileTopPanelActions
              isFilterSelected={isMobileFilterSelected}
              isSortSelected={isMobileSortSelected}
              onFilterClick={() =>
                this.setState({
                  isMobileFilterSelected: !isMobileFilterSelected,
                })
              }
              onSortClick={() =>
                this.setState({ isMobileSortSelected: !isMobileSortSelected })
              }
            />
          }
          <div className='page-actions'>
            <button
              type='button'
              onClick={() => this.setState({ isBulkUploadModalOpen: true })}
              className='btn btn-primary pull-right'
            >
              Bulk Upload
            </button>
            <button
              type='button'
              onClick={() => this.setState({ isCreateModalOpen: true })}
              className='btn btn-primary pull-right'
            >
              Create Experience
            </button>
          </div>
        </TopPanel>
        <div className='data-container'>
          <ActivityFilterForm
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            filterActivity={this.getFilteredActivity}
            cities={cities}
            tags={tags}
            filterData={filterData}
            clear={this.removeFilter}
            isMobileFilterSelected={isMobileFilterSelected}
            csvActivities={csvActivities}
            csvBookingOptions={csvBookingOptions}
            loadCSVActivities={this.loadCSVActivities}
          />
          <MobileListSorter
            isSortSelected={isMobileSortSelected}
            activeSort={activeSort}
            availableSort={avaliableSort}
            changeSortBySelect={this.changeSortBySelect}
          />
          <div className='clearfix' />
          {activities.length !== 0 ? (
            <div key={key} className='table-box tab-cont small-height'>
              <InfiniteSccroll
                pageStart={0}
                loadMore={this.loadMoreActivities}
                useWindow={false}
                hasMore={!allActivities}
                loader={
                  <Glyphicon key={0} glyph='refresh' className='spinning' />
                }
              >
                <ActivitiesList
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  activities={activities}
                  changeSort={this.changeSort}
                  activeSort={activeSort}
                  handleOnClick={this.handleActivityClick}
                />
              </InfiniteSccroll>
            </div>
          ) : (
            <h2>Activities list is empty</h2>
          )}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    filterData: state.activities.activityFilters,
    activeFilter: state.activities.activeFilter,
    tag: state.activities.tag,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
    clearTag: () => dispatch(setTag(undefined)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Activities);
